import React from "react";
import styled from "styled-components";

const NavList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`;
export default NavList;



// WEBPACK FOOTER //
// ./src/views/AppViews/Sidebar/components/Nav/NavList/index.jsx